// This code has been partially generated by an AI.
import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { ClickOutside } from 'ngxtension/click-outside';
import { heroMoon, heroSun, heroTv } from '@ng-icons/heroicons/outline';
import { RouterLink } from '@angular/router';
import { ThemeEnum } from '@app/_api/enums/theme.enum';
import { VisibilitySettingsNotificationDialogComponent } from '@app/features/visibility-settings-notification-dialog/visibility-settings-notification-dialog.component';
import { ThemeService } from '@app/core/services/theme.service';
import { PollService } from '@app/core/services/poll.service';
import { DialogService } from '@app/core/services/dialog.service';
import { EmployeeBasicDto, EmployeeDto, StatusGroup } from '@app/_api/dto';
import { EmployeeDataService } from '@app/core/services/employee-data.service';
import { RoleEnum } from '@app/_api/enums/role.enum';
import { RolePermissionBuilder } from '@app/shared/permission/role-permission-builder';
import { RolePermission } from '@app/shared/permission/role.permission';
import { ProfilePictureComponent } from '@app/shared/components/profile-picture/profile-picture.component';
import { ProfilePictureUploadComponent } from '@app/shared/components/profile-picture/profile-picture-upload/profile-picture-upload.component';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'if-profile-dropdown',
  imports: [NgIcon, ProfilePictureComponent, ProfilePictureUploadComponent, ClickOutside, RouterLink],
  templateUrl: './profile-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  viewProviders: [provideIcons({ heroTv, heroMoon, heroSun })],
})
export class ProfileDropdownComponent {
  readonly themeService = inject(ThemeService);
  showOptions = false;
  adminSettingsPermission!: RolePermission;
  statusGroupLabels: string[] = [];
  employee!: EmployeeBasicDto;

  protected employeeLoaded: EmployeeDto | undefined = undefined;
  protected readonly ThemeEnum = ThemeEnum;
  protected readonly employeeDataService = inject(EmployeeDataService);
  protected readonly RoleEnum = RoleEnum;

  private readonly pollService = inject(PollService);
  private readonly dialogService = inject(DialogService);
  private readonly keycloak = inject(Keycloak);
  private totalStatusGroups: StatusGroup[] | undefined = undefined;
  private initialized = false;

  constructor() {
    effect(() => {
      this.employeeLoaded = this.employeeDataService.employee();
      this.totalStatusGroups = this.employeeDataService.allStatusGroups();
      if (this.employeeLoaded && this.totalStatusGroups && !this.initialized) {
        this.initialized = true;
        this.initialization();
      }
    });
  }

  initialization(): void {
    this.employee = {
      uuid: this.employeeLoaded!.uuid,
      firstname: this.employeeLoaded!.firstname,
      lastname: this.employeeLoaded!.lastname,
    } as EmployeeBasicDto;
    this.statusGroupLabels = this.employeeLoaded!.statusGroups.map(statusGroup => statusGroup.name);
    this.adminSettingsPermission = RolePermissionBuilder.builder()
      .authorizeRole(RoleEnum.ADMIN)
      .authorizeRole(RoleEnum.PERSONAL)
      .authorizeRole(RoleEnum.REVIEWER)
      .comparing(this.employeeLoaded!.role);
  }

  openFeedbackDialog() {
    this.pollService.feedbackDialog(false);
  }

  onVisibilityButtonClick() {
    this.dialogService.open(VisibilitySettingsNotificationDialogComponent);
  }

  logout() {
    this.keycloak.logout();
  }
}
